import React from 'react';

import SpotlerSubscriptionForm from '../../../../components/Form/SpotlerSubscriptionForm';

import './style.scss';

const EmailAccountPage: React.FC = () => (
  <SpotlerSubscriptionForm
    // @ts-ignore
    onSuccess={(isNew) => {
      let gtmEventName = 'spotler_subscription_update';
      if (isNew) {
        gtmEventName = 'spotler_subscription_create_logged_in';
      }
      // Push custom GTM event
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: gtmEventName,
      });
    }}
  />
);

export default EmailAccountPage;
